import { render, staticRenderFns } from "./guestDetailnew.vue?vue&type=template&id=6620642f&scoped=true&"
import script from "./guestDetailnew.vue?vue&type=script&lang=js&"
export * from "./guestDetailnew.vue?vue&type=script&lang=js&"
import style0 from "./guestDetailnew.vue?vue&type=style&index=0&id=6620642f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620642f",
  null
  
)

export default component.exports